<script lang="ts" context="module">
  import type { InventoryItem, InventoryItemType } from "models/InventoryItem";

  type InventoryItemSearchParams = {
    q: string;
    area_id?: number;
    branch_id?: number;
    types?: InventoryItemType[];
  };

  function labelFor(inventoryItem: InventoryItem): string {
    return [inventoryItem.name].filter((v) => v && v.length > 0).join(" ");
  }
</script>

<script lang="ts">
  import Select from "svelte-select";
  import axios from "axios";

  export let inputId: string;
  export let inputName: string;
  export let value: number | null = null;
  export let label: string | undefined = undefined;
  export let placeholder = "Find by name, SKU, or barcode...";

  export let areaId: number | null = null;
  export let branchId: number | null = null;
  export let itemTypes: InventoryItemType[] | undefined = undefined;
  export let selected: InventoryItem | null = null;
  export let onSelected: (selected: InventoryItem) => void = () => {};
  export let clearAfterSelect = false;

  let filterText: string;
  const inputAttributes = { id: inputId, autocomplete: "off" };

  async function fetchInventoryItems(filterText: string): Promise<InventoryItem[]> {
    let results: InventoryItem[] = [];

    if (filterText.length < 3) {
      return results;
    }

    try {
      const url = "/api/v1/inventory_items";
      const params: InventoryItemSearchParams = { q: filterText };
      if (areaId) params.area_id = areaId;
      if (branchId) params.branch_id = branchId;
      if (itemTypes) params.types = itemTypes;

      const response = await axios.get(url, { params });

      if (response.status == 200) {
        results = response.data.inventory_items;
      }
    } catch (err) {
      console.error(err);
    }

    return results;
  }

  const onChange = (event: { detail: InventoryItem }) => {
    const inventoryItem = event.detail;
    value = inventoryItem.id;
    onSelected(inventoryItem);
    if (clearAfterSelect) {
      selected = null;
      value = null;
    }
  };

  const onClear = () => {
    selected = null;
    value = null;
  };
</script>

<div class="form-group">
  {#if label}
    <label for={inputId}>{label}</label>
  {:else}
    <label for={inputId} class="sr-only">{placeholder}</label>
  {/if}

  <input type="hidden" name={inputName} bind:value />

  <Select
    loadOptions={fetchInventoryItems}
    {placeholder}
    {inputAttributes}
    --height="32px"
    --item-height="48px"
    on:change={onChange}
    on:clear={onClear}
    bind:value={selected}
    bind:filterText
  >
    <div slot="item" let:item>
      <div class="pt-2 d-flex align-items-center">
        <!-- {#if item.sku && item.sku.length > 0}
          <div class="text-secondary pe-4">
            <i class="fas fa-tag" />
            {item.sku}
          </div>
        {/if} -->

        <div>{item.name}</div>
      </div>
    </div>

    <div slot="selection"><slot name="selection">{selected ? labelFor(selected) : ""}</slot></div>

    <div slot="empty" class="d-flex pt-2 align-items-center justify-content-center">
      {#if filterText?.length >= 3}
        <p class="text-secondary">No results, please try another search</p>
      {:else}
        <p class="text-info fst-italic">You must type atleast 3 characters to start searching</p>
      {/if}
    </div>
  </Select>
</div>
